import { BreadcrumbsItem as BreadcrumbsItemBase } from '../../CommonComponents/OPL/Breadcrumbs/Breadcrumbs.types';
import { useRouteParams } from './useRouteParams';

interface Params {
  path: string | null;
}

interface BreadcrumbsItem extends BreadcrumbsItemBase {
  path: string;
}

export const pathList = (path: string) => {
  return decodeURIComponent(path)
    .split('/')
    .filter(_path => _path !== '')
    .reduce(
      (acc, folderName, index) => [
        ...acc,
        {
          id: index,
          title: folderName,
          path: `${acc[index]?.path || ''}${folderName}/`,
        },
      ],
      [
        {
          id: 'home',
          title: 'Home',
          path: '',
        },
      ] as BreadcrumbsItem[],
    );
};

export const useBreadcrumbsItems = (): BreadcrumbsItem[] => {
  const { path } = useRouteParams();

  return pathList(path);
};
